






































import Vue from 'vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import {
  ClickUpUrlForGiveFeedbackLink,
  ClickupUrlForRequestFeatureLink
} from '../lib/constants';
import Features from '../lib/featureFlags';
import { VuexLocalStorage } from '../lib/vuexLocalStorage';
import moment from 'moment';

const storage = new VuexLocalStorage('_USER_');
const clientStorage = new VuexLocalStorage('_CLIENT_');
const userPreferenceStorage = new VuexLocalStorage('_USER_PREFERENCE_');

export default Vue.extend({
  name: 'NavigationPhone',
  data() {
    return {
      ClickupUrlForRequestFeatureLink,
      ClickUpUrlForGiveFeedbackLink
    };
  },
  computed: {
    ...mapState('user', {
      userName: 'firstName',
      creditsAvailable: 'creditsAvailable',
      userCreatedAt: 'createdAt'
    }),
    ...mapState('client', {
      subscribersCounts: 'subscribersCounts',
      isTelkomClient: 'isTelkomClient',
      messageSendingPhoneNumber: 'messageSendingPhoneNumber'
    }),
    ...mapGetters('client', ['isTelkomClient']),

    hasPhone(): boolean {
      return !!this.messageSendingPhoneNumber;
    }
  }
});
